import {
  formatSolListingPriceFromNumber,
  parseSolanaListingPriceSolToLamports,
} from "@/app/solana/listing-price"
import { getRawAddress } from "@anaconda/core/blockchain/address"
import type { Nft } from "@anaconda/core/nft/types"
import { toCurrencyId } from "@anaconda/core/price/types"
import { isItemBidSupportedNftStandard } from "@rarible_int/anaconda_sdk/solana"
import { sonnerToast } from "@rarible_int/anaconda_ui_components"
import { useMolecule } from "bunshi/react"
import { useCallback, useMemo } from "react"
import { getTransactionErrorMessage } from "../events/transaction-event"
import { SolanaItemOfferTransactionMoleculeReatom } from "./solana-item-offer-molecule.reatom"

export function useSolanaItemOffer(nft: Nft) {
  const { itemOfferActionFactory } = useMolecule(
    SolanaItemOfferTransactionMoleculeReatom,
  )
  const itemOfferAction = useMemo(
    () => itemOfferActionFactory(),
    [itemOfferActionFactory],
  )

  const mutate = useCallback(
    (params: { price: number; currency: string }) => {
      void (async () => {
        try {
          // The item's own standard, not the collection's: a collection can hold
          // a mix, and fill_v2 binds the transfer branch to order.nft_standard.
          if (!isItemBidSupportedNftStandard(nft.nftStandard)) {
            sonnerToast.error(
              "This NFT standard doesn't support item offers. Make a collection offer instead.",
            )
            return
          }

          const priceInLamports = parseSolanaListingPriceSolToLamports(
            formatSolListingPriceFromNumber(params.price),
          )

          await itemOfferAction({
            itemMint: getRawAddress(nft.id),
            nftStandard: nft.nftStandard,
            currency: toCurrencyId(params.currency),
            price: priceInLamports,
          }).catch(() => undefined)
        } catch (error) {
          sonnerToast.error(getTransactionErrorMessage(error))
        }
      })()
    },
    [itemOfferAction, nft.id, nft.nftStandard],
  )

  return {
    mutate,
    isPending: !!itemOfferAction.pending(),
  }
}
